import { render } from "./SubmitPurchase.vue?vue&type=template&id=24dcd1b2"
import script from "./SubmitPurchase.vue?vue&type=script&lang=js"
export * from "./SubmitPurchase.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__